import React, { Component } from 'react'
import moment from 'moment-timezone'
import { Link } from 'react-router-dom'
import { authService, clientService, fvpClientFundingService } from '../../../../services'
import { formatter, validator } from '../../../../util'
import { JobFilterType, JobListType } from '../../../../constants'
import { jobURL, timezone } from '../../../../config'

import Button from 'antd/lib/button'
import Col from 'antd/lib/col'
import Form from 'antd/lib/form'
import Row from 'antd/lib/row'
import Icon from 'antd/lib/icon'
import Radio from 'antd/lib/radio'
import Modal from 'antd/lib/modal'
import Select from 'antd/lib/select'
import Steps from 'antd/lib/steps'
import Spin from 'antd/lib/spin'
import Tooltip from 'antd/lib/tooltip'

import '../../styles.css'

const { Item: FormItem } = Form
const { confirm, warning } = Modal
const Option = Select.Option
const Step = Steps.Step
const RadioButton = Radio.Button
const RadioGroup = Radio.Group

const dateFormat = 'DD/MM/YYYY'
const timeFormat = 'hh:mm A'
const JobSinglePageURL = `${jobURL}/${JobListType.JOB_LIST_SINGLE}`

moment.tz.setDefault(timezone)

class SingleJobView extends Component {
  handleCheckJobAffectedStatus = (job) => {
    const { item, filterType, listType } = this.props
    const { is_single_updated: isUpdated } = item

    // only single job list shown in recurring job single job list will need this affected alert
    if (listType === JobListType.JOB_LIST_RECURRING && filterType) {
      if (filterType !== JobFilterType.JOB_TYPE_PAST) {
        if (isUpdated) {
          return 1
        }
      }
    }

    return 0
  }

  render () {
    const { item, filterType, listType } = this.props
    const {
      id,
      job_start_date,
      job_end_date,
      base_job_id,
      client_id,
      employee_id,
      funder_id,
      is_employee_pending,
      category_id,
      payroll,
      tasks,
      emergency,
      emergency_pay,
      emergency_invoice,
      is_cancel,
      cancellation_penalty,
      ts_signed_id,
      is_sleepover_job,
      client_fullname,
      employee_fullname,
      funder_fullname,
      client_suburb,
      is_job_feedback,
      string_job_start_day,
      holiday_date,
      holiday_name,
      client_leave_id,
      client_leave_start_date,
      client_leave_end_date,
      client_leave_is_ufn,
      employee_leave_id,
      employee_leave_start_date,
      employee_leave_end_date,
      acvd_client_names,
      acvd_employee_names
    } = item

    const isUpdated = this.handleCheckJobAffectedStatus(item)

    const isClientLeave = !!client_leave_id
    const clientLeaveText = isClientLeave ? `Leave ${formatter.toShortDate(client_leave_start_date)} - ${client_leave_is_ufn ? 'UFN' : formatter.toShortDate(client_leave_end_date)}` : null

    const isEmployeeLeave = !!employee_leave_id
    const employeeLeaveText = isEmployeeLeave ? `Leave ${formatter.toShortDate(employee_leave_start_date)} - ${formatter.toShortDate(employee_leave_end_date)}` : null

    const dateText = `${formatter.toDurationTextFormat(job_start_date, job_end_date, dateFormat)}`
    const timeText = `${formatter.toDurationTextFormat(job_start_date, job_end_date, timeFormat)}`
    const timeDuration = `${formatter.toDurationDiff(job_start_date, job_end_date)}`
    const timeDurationText = is_sleepover_job ? `Sleepover` : `${timeDuration} Hour${timeDuration === 1 ? '' : 's'}`

    const isClashedMembers = acvd_client_names || acvd_employee_names
    const clashMembersDiv = isClashedMembers
      ? <div>
        { acvd_client_names ? <div>Same address with client: {acvd_client_names}</div> : null }
        { acvd_employee_names ? <div>Same address with client: {acvd_employee_names}</div> : null }
      </div>
      : null

    return (
      <div className={`list-item ${isUpdated === 1 ? 'warning' : holiday_date ? 'highlight' : ''} ${is_employee_pending === true && employee_id ? 'pending-assigned-highlight' : ''}`} key={`amcs-${id}`}>
        <Row>
          <Col lg={1}>
            { is_employee_pending === true && employee_id
              ? <Tooltip title='Pending Employee (Assigned)'><div className='list-indicator pending-assigned'><span>P</span></div></Tooltip>
              : null }
            { listType === JobListType.JOB_LIST_RECURRING
              ? (is_cancel
                  ? <div className='list-indicator'>
                    <Icon type='close-circle' theme='twoTone' twoToneColor='#eb2f96' />
                  </div>
                  : <div className='list-indicator'>
                    <Icon type='check-circle' />
                  </div>)
              : listType === JobListType.JOB_LIST_SINGLE
                ? (<div>
                  { emergency_invoice && emergency_pay
                    ? <div className='list-indicator emergency'><span>EE</span></div>
                    : emergency_invoice
                      ? <div className='list-indicator emergency-invoice'><span>EI</span></div>
                      : emergency_pay
                        ? <div className='list-indicator emergency-pay'><span>EP</span></div>
                        : null }
                  { cancellation_penalty ? <div className='list-indicator late'><span>LC</span></div> : null }
                  { base_job_id > 0 ? <div className='list-indicator recur'><span>R</span></div> : null }
                  { is_job_feedback ? <Tooltip title='Job Feedback'><div className='list-indicator feedback'><span>F</span></div></Tooltip> : null }
                </div>)
                : null }
          </Col>
          <Col lg={22}>
            <Row className='bottom-border'>
              <Col lg={8}>
                <Row>
                  <Col lg={5}>
                    <div className='subtitle'>Client</div>
                  </Col>
                  <Col lg={14}>
                    <div className='name'>
                      <a href={`/clients/${client_id}`} rel='noopener noreferrer' target='_blank'>
                        {client_fullname}
                      </a>
                      { clientLeaveText
                        ? <div className='warning-text'>
                            <Icon type='exclamation-circle' theme='twoTone' twoToneColor='#ff0000' />
                            &nbsp;{ clientLeaveText }
                        </div>
                        : null }
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col lg={8}>
                <Row>
                  <Col lg={6}>
                    <div className='subtitle'>Employee</div>
                  </Col>
                  <Col lg={14}>
                    { employee_id
                      ? <a href={`/employees/${employee_id}/info`} rel='noopener noreferrer' target='_blank'>
                        {employee_fullname}
                      </a>
                      : <div className='disabled'>Unassigned</div> }
                    { employeeLeaveText
                      ? <div className='warning-text'>
                        <Icon type='exclamation-circle' theme='twoTone' twoToneColor='#ff0000' />
                        &nbsp;{ employeeLeaveText }
                      </div>
                      : null }
                  </Col>
                </Row>
              </Col>
              <Col lg={8}>
                <Row>
                  <Col lg={5}>
                    <div className='subtitle'>Funder</div>
                  </Col>
                  <Col lg={14}>
                    <div className='name'><a href={`/funders/${funder_id}`} rel='noopener noreferrer' target='_blank'>{funder_fullname}</a></div>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row style={{ marginTop: 15 }}>
              <Col md={8}>
                <div className='detail'>
                  <Icon type='calendar' />
                  &nbsp;&nbsp;{ dateText }
                  { holiday_date
                    ? <Tooltip title={holiday_name} mouseEnterDelay={0} mouseLeaveDelay={0}>
                      &nbsp;<Icon type='bell' theme='twoTone' style={{ fontSize: '14px' }}  />
                    </Tooltip>
                    : null }
                  <span className='indicator'>{formatter.capitalize(string_job_start_day)}</span></div>
              </Col>
              <Col md={8}>
                <div className='detail'>
                  <Icon type='clock-circle' />
                  &nbsp;&nbsp;{ timeText }
                  <span className='indicator'>{timeDurationText}</span>
                </div>
              </Col>
              <Col md={6}>
                <div className='detail'>
                  <Icon type='environment' />
                  &nbsp;&nbsp;{client_suburb}&nbsp;
                  { clashMembersDiv
                    ? <span className='marker'>
                      &nbsp;
                      <Tooltip
                        title={(
                          clashMembersDiv
                        )}
                        mouseEnterDelay={0}
                        mouseLeaveDelay={0}
                      >
                        <Icon type='home' theme='twoTone' twoToneColor='#d60b29' />
                      </Tooltip>
                    </span>
                    : null }
                </div>
              </Col>
            </Row>
            <Row style={{ marginTop: 5 }}>
              <Col>
                <div className='detail-normal'>{ tasks ? formatter.toShortenText(tasks, 350) : tasks }</div>
              </Col>
            </Row>
          </Col>
          <Col lg={1} className='action-icon'>
            { this.hasAccess('readJob') || this.hasAccess('updateJob')
              ? <Link to={`${JobSinglePageURL}/${id}/info`}>
                <div className='edit-button'>
                  <Tooltip mouseLeaveDelay={0} title='Manage job'>
                    <Icon type='form' />
                  </Tooltip>
                </div>
              </Link>
              : null }
          </Col>
        </Row>
      </div>
    )
  }

  hasAccess = (accessLevel) => {
    return authService.hasAccess(accessLevel)
  }
}

export default SingleJobView
